export default __webpack_public_path__ + "static/Corprate_WhoWeAre_aboutus_01-cb4170d938a82121d490a2b2d1691028.jpg";